// extracted by mini-css-extract-plugin
export default {"tabContent":"_852b2013","contentActive":"_75ee0581"};